import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

export const devadminGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (environment.production) {
    router.navigate(['/']);
    return false;
  }

  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (!isLocalhost) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
